@if (initialized) {
    <div class="grid">
        <!-- Upload Section -->
        <div class="col-12 lg:col-3">
            <div class="card">
                <h5 class="mb-3">Upload File</h5>
                <ea-file-upload-widget
                        [projectId]="objectIdentifier.objectId"
                        (onFileUploaded)="handleFileUploaded($event)"
                ></ea-file-upload-widget>
            </div>
        </div>

        <!-- File List -->
        <div class="col-12 lg:col-9">
            <div class="card">
                <mvs-widget
                        *ngIf="sourceFilesWidget"
                        [widgetData]="sourceFilesWidget"
                        (onObjectSelect)="handleFileSelect($event)"
                ></mvs-widget>
            </div>
        </div>

        <!-- Preview Section -->
        @if (selectedFile) {
            <div class="col-12">
                <div class="card">
                    <h5 class="mb-3">File Preview: {{ selectedFile.name }}</h5>
                    <ea-file-preview-widget
                            [sourceFileId]="selectedFile.id"
                    ></ea-file-preview-widget>
                </div>
            </div>
        }
    </div>
}
